/**
 * Lottie animations — [data-lottie] elements load lottie-web on demand.
 * Markup: single-service.php (ACF featured_animation_lottie_json).
 *
 * lottie-web is only fetched when the page actually has one of these, so
 * pages without an animation don't pay for the library.
 *
 * Imports the "light" build (no expressions engine) rather than the default
 * one: the full build's expression engine runs arbitrary After Effects
 * expressions through a direct eval(), which our JSON exports never use
 * anyway — the light build drops that whole eval-based code path (and is
 * ~235KB smaller uncompressed) instead of just quieting the build's eval warning.
 */
function initLottieAnimations() {
	const nodes = document.querySelectorAll( '[data-lottie]' );
	if ( ! nodes.length ) {
		return;
	}

	import( 'lottie-web/build/player/lottie_light' ).then( ( { default: lottie } ) => {
		nodes.forEach( ( node ) => {
			const path = node.dataset.lottieSrc;
			if ( ! path ) {
				return;
			}

			lottie.loadAnimation( {
				container: node,
				renderer: 'svg',
				loop: false,
				autoplay: true,
				path,
			} );
		} );
	} );
}

initLottieAnimations();
